class Controller {
  constructor(Events, $stateParams, $injector) {
    "ngInject";

    this.Events = Events;
    this.$stateParams = $stateParams;
    this.activeParams = this.$stateParams;
    this.sections = $injector.get("Sections").customersSections;
    this.filterEvent = this.Events.getFilterEvent("customers");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/customers/customers.controller.js